import EditCategory from './edit_postal_code'
import { reduxForm } from 'redux-form'
import { updateRemotely } from 'redux/modules/campaign'
import { getCampaignSelector } from 'redux/selectors/campaign'
import { combine, required } from 'lib/validators'
import { postalCodeValidator } from 'lib/postal_code_validator'
import { getI18n } from 'client/i18n'

const i18n = getI18n('components/edit_glimpse/edit_postal_code')

const mapStateToProps = (state, props) => {
  const campaign = getCampaignSelector(state, props)

  let validators = [
    required('postalCode', i18n('postal_code_required')),
    ...postalCodeValidator('postalCode', i18n('postal_code_should_be_valid')),
  ]

  return {
    validate: combine(...validators),
    initialValues: {
      postalCode: campaign.postal_code,
    },
    campaignType: campaign.campaign_type,
  }
}

const mapDispatchToProps = (dispatch, { campaignId }) => {
  return {
    onSave(formValues) {
      return dispatch(
        updateRemotely(campaignId, { postal_code: formValues.postalCode })
      )
    },
  }
}

export default reduxForm(
  {
    form: 'edit_category',
    fields: ['postalCode'],
  },
  mapStateToProps,
  mapDispatchToProps
)(EditCategory)
